import React, { useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Grid,
  makeStyles,
} from "@material-ui/core";
import Page from "src/components/Page";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import BudgetManagementFormComponent from "src/components/forms/BudgetManagementFormComponent/BudgetManagementFormComponent";
import {
  clearReportBudgetManagement,
  getReportBudgetManagement,
} from "src/redux/actions/report.action";
import { priceNumberFormat } from "src/utils/Number";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

export default function BudgetManagementComponent() {
  const dispatch = useDispatch();

  const classes = useStyles();

  const { budgetManagement } = useSelector((state) => state.reportReducer);

  useEffect(() => {
    dispatch(clearReportBudgetManagement());
    return () => {};
  }, []);

  return (
    <Page className={classes.root} title="Budget Management">
      <Container maxWidth={false}>
        <Card>
          <CardHeader
            subheader="For the budget transaction on the system."
            title="Budget Management"
          />
          <Divider />
          <CardContent>
            <Box display="flex" justifyContent="flex-end">
              <BudgetManagementFormComponent
                onSubmit={(value) => {
                  dispatch(getReportBudgetManagement(value));
                }}
              />
            </Box>
            <Box mt={3}>
              <Grid container spacing={3}>
                <MaterialTable
                  title
                  isLoading={budgetManagement.isLoading}
                  columns={[
                    {
                      title: "CODE",
                      field: "ACC_CODE",
                    },
                    {
                      title: "PROJECT CODE",
                      field: "BUDGETP_CODE",
                    },
                    {
                      title: "NAME",
                      field: "ACC_NAME",
                    },
                    {
                      title: "BRAND",
                      field: "BRAND_NAME",
                    },
                    {
                      title: "DEPARTMENT",
                      field: "DEPARTMENT_NAME",
                    },
                    {
                      title: "INITIAL",
                      field: "BUDGETSD_INITIAL",
                      render: (rowData) => {
                        return priceNumberFormat(rowData.BUDGETSD_INITIAL);
                      },
                    },
                    {
                      title: "REVISED",
                      field: "REVISE",
                      render: (rowData) => {
                        return priceNumberFormat(rowData.REVISE);
                      },
                    },
                    {
                      title: "BALANCE",
                      field: "BALANCE",
                      render: (rowData) => {
                        return priceNumberFormat(
                          rowData.BUDGETSD_INITIAL + rowData.REVISE
                        );
                      },
                    },
                    {
                      title: "REMAIN",
                      field: "REMAINING",
                      render: (rowData) => {
                        return priceNumberFormat(rowData.REMAINING);
                      },
                    },
                  ]}
                  data={budgetManagement.data}
                  options={{
                    filtering: true,
                  }}
                  style={{
                    width: "100%",
                  }}
                />
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
